/**
 * default prefix "TOP_BAR_BOARD"
 **/
export const AT_TOP_BAR_BOARD_ACTION_SET = 'TOP_BAR_NAME_STATUS_SET';
